import React from 'react';
import './VideoResult.css';

const VideoResult = ({ videoData, platform = 'tiktok' }) => {
  const handleDownload = (url, filename) => {
    // Create a temporary link and trigger download
    const link = document.createElement('a');
    link.href = url;
    link.download = filename;
    link.target = '_blank';
    document.body.appendChild(link);
    link.click();
    document.body.removeChild(link);
  };

  const platformName = platform === 'youtube' ? 'YouTube' : 'TikTok';
  const filePrefix = platform === 'youtube' ? 'youtube' : 'tiktok';

  return (
    <div className="video-result">
      <div className="video-result-header">
        {videoData.coverImage && (
          <img 
            src={videoData.coverImage} 
            alt="Video thumbnail" 
            className="video-thumbnail"
          />
        )}
        
        <div className="video-info">
          <div className="author-section">
            {videoData.avatarThumb && (
              <img 
                src={videoData.avatarThumb} 
                alt={videoData.author} 
                className="author-avatar"
              />
            )}
            <span className="author-name">
              {platform === 'youtube' ? videoData.author : `@${videoData.author}`}
            </span>
          </div>
          
          {videoData.description && (
            <p className="video-description">{videoData.description}</p>
          )}
          
          <div className="video-meta">
            <span className="meta-tag">📱 {platformName}</span>
            {videoData.duration && (
              <span className="meta-tag">⏱️ {videoData.duration}</span>
            )}
            {videoData.quality && (
              <span className="meta-tag">🎥 {videoData.quality}</span>
            )}
            {videoData.videoId && (
              <span className="meta-tag">🎬 ID: {videoData.videoId}</span>
            )}
          </div>
        </div>
      </div>
      
      <div className="download-options">
        {videoData.videoUrl && (
          <button 
            className="download-option"
            onClick={() => handleDownload(videoData.videoUrl, `${filePrefix}_${videoData.videoId || 'video'}.mp4`)}
          >
            <span>⬇️</span>
            <span>Download Video {platform === 'tiktok' ? '(No Watermark)' : ''}</span>
          </button>
        )}
        
        {videoData.videoWithWatermark && platform === 'tiktok' && (
          <button 
            className="download-option secondary"
            onClick={() => handleDownload(videoData.videoWithWatermark, `${filePrefix}_${videoData.videoId}_watermark.mp4`)}
          >
            <span>⬇️</span>
            <span>Download Video (With Watermark)</span>
          </button>
        )}
        
        {videoData.musicUrl && (
          <button 
            className="download-option music"
            onClick={() => handleDownload(videoData.musicUrl, `${filePrefix}_${videoData.videoId || 'audio'}_audio.mp3`)}
          >
            <span>🎵</span>
            <span>Download Audio (MP3)</span>
          </button>
        )}
      </div>
    </div>
  );
};

export default VideoResult;
